import { render } from "./MinProfile.vue?vue&type=template&id=6d8ca000&scoped=true"
import script from "./MinProfile.vue?vue&type=script&lang=js"
export * from "./MinProfile.vue?vue&type=script&lang=js"

import "./MinProfile.vue?vue&type=style&index=0&id=6d8ca000&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d8ca000"]])

export default __exports__